import { c as _c } from "react/compiler-runtime";
import { ProjectLocationEditor } from "@components/project-location-editor/project-location-editor";
import { MapLargeIcon, MenuItem } from "@flat-ui";
import { trackOpenProjectLocationEditor } from "@utils/project-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";
/**
 * Menu item component that opens the ProjectLocationEditor dialog when clicked.
 */
export function ProjectLocationEditorMenuItem(t0) {
  const $ = _c(13);
  const {
    project,
    closeMenu
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t1;
  if ($[0] !== trackEvent) {
    t1 = function openDialog() {
      trackOpenProjectLocationEditor({
        trackEvent,
        source: "project card menu"
      });
      setIsDialogOpen(true);
    };
    $[0] = trackEvent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const openDialog = t1;
  let t2;
  if ($[2] !== closeMenu) {
    t2 = function closeDialog() {
      closeMenu();
      setIsDialogOpen(false);
    };
    $[2] = closeMenu;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const closeDialog = t2;
  let t3;
  if ($[4] !== openDialog) {
    t3 = <MenuItem label="Edit location" Icon={MapLargeIcon} onClick={openDialog} />;
    $[4] = openDialog;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== closeDialog || $[7] !== isDialogOpen || $[8] !== project) {
    t4 = isDialogOpen && <div onKeyDown={_temp}><ProjectLocationEditor project={project} onClose={closeDialog} /></div>;
    $[6] = closeDialog;
    $[7] = isDialogOpen;
    $[8] = project;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp(e) {
  return e.stopPropagation();
}